module.exports = __webpack_public_path__ + "img/Cat_and_medication.a7138608.jpeg";